<template>
	<div class="row">
		<div class="col-12">
			<ul class="list-group account__info__list">
				<li class="list-group-item name">
					{{ user.firstname }} {{ user.lastname }}
				</li>
				<li class="list-group-item account">
					<b>Solde</b> {{ formatToMoney(user.balance) }}
				</li>
				<li class="list-group-item payin">
					<router-link :to="{name: 'UserPayin'}">{{ t('page.user.link.payin') }}</router-link>
				</li>
				<li class="list-group-item payout">
					<router-link :to="{name: 'UserPayout'}">{{ t('page.user.link.payout') }}</router-link>
				</li>
			</ul>
			<div class="row">
				<div class="col-12">
					<self-exclude></self-exclude>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import Vuex from 'vuex';
	import UserSelfExclude from '@/components/user/UserSelfExclude';

	export default {
		name: 'user-info',
		components:{
			'self-exclude': UserSelfExclude
		},
		data() {
			return {
				selfExcludeModal: false
			}
		},
		computed:{
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				user: 'getUser',
				userLogedIn: 'getUserStatus'
			}),
		}
	}
</script>